module.exports = __webpack_public_path__ + "static/media/anticaking_graph.42fc98d3.png";